/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index list-format to autogenerate all the components and extensions
 * Used by "prepareListFormats"
 */

import ListFormat from './list-format/ListFormat'
export * from './list-format/ListFormat'
export default ListFormat
